import { render, staticRenderFns } from "./OccupancyBlockOverlay.vue?vue&type=template&id=5423455a&scoped=true"
import script from "./OccupancyBlockOverlay.vue?vue&type=script&lang=js"
export * from "./OccupancyBlockOverlay.vue?vue&type=script&lang=js"
import style0 from "./OccupancyBlockOverlay.vue?vue&type=style&index=0&id=5423455a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5423455a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5423455a')) {
      api.createRecord('5423455a', component.options)
    } else {
      api.reload('5423455a', component.options)
    }
    module.hot.accept("./OccupancyBlockOverlay.vue?vue&type=template&id=5423455a&scoped=true", function () {
      api.rerender('5423455a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/governance/components/OccupancyBlockOverlay.vue"
export default component.exports